import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import {
  plannerItemTypeHeightMap,
  eventTopSpacing
} from '../planner-constants';
import EventSkeleton from '../Skeletons/EventSkeleton';

export const MicroText = styled.p`
  font-size: ${Fonts.EXTRA_SMALL};
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  letter-spacing: 0.02em;
  width: 80px;
  text-align: center;
  color: var(--color-text-secondary);
`;

export const PlannerItemWrapper = styled.div`
  padding-top: ${eventTopSpacing}px;
  height: ${({ $height }) => $height}px;
`;

export const PlannerItemSkeletonWrapper = styled(PlannerItemWrapper)`
  padding-left: ${Spacings.SPACING_23B};
`;

export const DefaultLoaderSkeleton = ({ metaItem }) => {
  return (
    <PlannerItemSkeletonWrapper
      $height={plannerItemTypeHeightMap[metaItem.plannerItemType]}
    >
      <EventSkeleton showTitle />
    </PlannerItemSkeletonWrapper>
  );
};
